<template>
  <div>
    <top-navbar />

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3">
          <i class="fa fa-angle-right"></i>
        </span>
        <span class="decoration">Maintenance Management</span>
        <span class="pfimg3">
          <i class="fa fa-angle-right"></i>
        </span>
        Maintenance List
      </h6>

      <div class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">

            <!-- SEARCH -->
            <div class="search-container">

              <div class="row">
                  <label class="custom-label" style="font-size: small;">Folder Location</label>
                <div class="col-md-8">
                <div class="form-group">

             
              <input
                v-model="location2"
                type="text"
                class="form-control bdr-rad mb-1"
                placeholder="Folder Location"
              />
              </div>

                </div>
                <div class="col-md-4">
              <button
                @click="Loaddata"
                class="btn btn-sm btn-outline-primary mb-1  bdr-rad"
              >
                Load
              </button>

                </div>


              </div>

              

<div class="form-group">
  <label class="custom-label" style="font-size: small;">Sub Folder 1</label>
  <select v-model="selectedFolder" class="form-control mb-1" @change="loadSubFolders2">
    <option value="">-- Select Folder --</option>
    <option
      v-for="(f, i) in folders"
      :key="i"
      :value="f"
      :style="{
        fontWeight: f.split('/').length === 1 ? 'bold' : 'normal',
        paddingLeft: (f.split('/').length - 1) * 10 + 'px'
      }"
    >
      {{ f }}
    </option>
  </select>
</div>

<div class="form-group" v-if="subfolders2.length">
  <label class="custom-label" style="font-size: small;">Sub Folder 2</label>
  <select v-model="selectedSubFolder2" class="form-control mb-1" @change="loadFiles">
    <option value="">-- Select Subfolder --</option>
    <option
      v-for="(f, i) in subfolders2"
      :key="i"
      :value="f"
    >
      {{ f }}
    </option>
  </select>
</div>



<div class="form-group">
  <label class="custom-label" style="font-size: small;">Select Files</label>

  <div
    v-for="(file, index) in files"
    :key="index"
    class="form-check"
  >
    <input
      type="checkbox"
      class="form-check-input"
      :id="'file_'+index"
      :value="file"
      v-model="selectedFiles"
    />

    <label class="form-check-label">
      {{ file }}
    </label>
  </div>
</div>



<div class="form-group" v-if="selectedFiles.length">
  <label class="custom-label" style="font-size: small;">
    Selected File List
  </label>

  <ul class="list-group bdr-rad">
    <li
      class="list-group-item py-1"
      v-for="(file,index) in selectedFiles"
      :key="index"
    >
      {{ file }}
    </li>
  </ul>
</div>



<div class="form-group">
    <label class="custom-label" style="font-size: small;">Search Criteria</label>
              <input
                v-model="keyword"
                type="text"
                class="form-control input5 input6 bdr-rad"
                placeholder="Search keyword..."
              />


              </div>

              <button
                @click="search"
                class="btn btn-sm btn-outline-primary mb-1 mt-1 bdr-rad"
              >
                Search
              </button>

              <!-- LOADER -->
              <div class="d-flex justify-content-center mt-3" v-if="isLoading">
                <div class="spinner-border text-primary">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <!-- RESULTS -->
           <div v-if="!isLoading">
  <div
    v-for="(group, index) in groupedResults"
    :key="index"
    class="matched-table mt-3"
  >
 <div class="mb-2">
  <strong>{{ group.header_info.title }}</strong><br>
  Line: {{ group.header_info.line_number }}<br>
  Aircraft: {{ group.header_info.airplane_id }}<br>
 {{ group.file || '-' }} - Page {{ group.page || '-' }}

</div>

    <table
      class="table table-hover table-sm table-borderless mt-2"
      style="font-size: small;"
    >
      <!-- TABLE HEADER (ONLY ONCE) -->
      <thead class="background_color2">
        <tr class="custom-label2">
            <th>Select</th>
          <th
            v-for="(h, j) in group.table_header"
            :key="j"
          >
            {{ h }}
          </th>
        </tr>
      </thead>

      <!-- MULTIPLE ROWS -->
     <tbody>
  <tr
    v-for="(row, rIndex) in group.rows"
    :key="rIndex"
  >
   <td>
      <input
  type="checkbox"
  v-model="selectedRows"
  :value="{
    file: group.file,
    page: group.page,
    headers: group.table_header,
    row: row,
    header_info: group.header_info || {}
  }"
/>
    </td>
   <td v-for="(header, cIndex) in group.table_header" :key="cIndex">
  {{ row[cIndex] }}   {{ row[header] }}
</td>


  </tr>
</tbody>

    </table>
  </div>
<button
  class="btn btn-success mt-3"
  @click="generateExcel"
  :disabled="!selectedRows.length"
>
export to excel
</button>
  <p v-if="searched && !groupedResults.length" class="mt-3">
    No results found.
  </p>
</div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <content-footer />
  </div>
</template>

<script>
import axios from "axios";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  data() {
   return {
    location: "",            // Main folder URL
    location2: "",            // Main folder URL
    folders: [],             // First-level folders
    subfolders2: [],         // Subfolders of selected folder
    selectedFolder: "",
    selectedSubFolder2: "",
    files: [],
    selectedFiles: [],
    selectedRows: [],
     results: [],
    keyword: "",
    isLoading: false,
    searched: false,
  };
  },

computed: {
 groupedResults() {

  const map = {};

  this.results.forEach((r) => {

    const page = r.page || r.sheet || "";   // ✅ safe fallback

    const key = `${r.file}_${page}`;

    if (!map[key]) {
      map[key] = {
        file: r.file || "",
        page: page,
        table_header: r.table_header || [],
        header_info: r.header_info || {},
        rows: [],
      };
    }

    if (r.matched_row && Array.isArray(r.matched_row)) {
      r.matched_row.forEach(row => {
        map[key].rows.push(row);
      });
    }

  });

  return Object.values(map);

},

},



  methods: {

    Loaddata() {
  this.folders = [];
  this.files = [];
  this.selectedFolder = "";
  this.selectedSubFolder2 = "";
  this.subfolders2 = [];

  // ✅ Clean full URL to relative path
  if (this.location2) {
  // Remove protocol + domain + project/web prefix
  let cleanedLocation = this.location2
    .replace(/^https?:\/\/[^/]+\/(DEMO_VUEJS\/web\/)?/, '') // remove domain + optional project/web
    .replace(/^\/+/, '') // remove leading slashes
    .replace(/\/+$/, ''); // remove trailing slashes
  this.location = cleanedLocation;

  console.log(this.location );
}

  axios.get("https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/aircraftfiles", {
    params: { location: this.location }
  }).then(res => {
    if (res.data.error) {
      alert(res.data.error);
      return;
    }
    console.log(res);
    this.folders = res.data.folders;
    this.files = res.data.files;
  });
},


  // Load 2nd-level subfolders when a folder is selected
  loadSubFolders2() {
  // Clear previous subfolder & files
  this.subfolders2 = [];
  this.selectedSubFolder2 = "";
  this.files = [];
  this.selectedFiles = [];

  if (!this.selectedFolder) return;

  // Construct full path to first-level folder
  const folderPath = this.location + '/' + this.selectedFolder;

  axios.get("https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/folderlist", {
    params: { location: folderPath }
  })
  .then(res => {
    console.log(res);
    if (res.data.error) {
      alert(res.data.error);
      return;
    }

    // If there are subfolders, show them in the Sub Folders 2 dropdown
    if (res.data.folders && res.data.folders.length > 0) {
      this.subfolders2 = res.data.folders;
    } else {
      // No subfolders → load files directly
      console.log(folderPath);
      this.loadFilesFromFolder(this.selectedFolder);
    }
  });
},


  // Load files from selected subfolder (2nd-level)
  loadFilesFromFolder(folderPath) {
    this.files = [];
    this.selectedFiles = [];

    axios.get("https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/filelist", {
      params: { folder: folderPath }
      
    }).then(res => {
      console.log(res);
      if (res.data.error) {
        alert(res.data.error);
        return;
      }

      this.files = res.data.files || [];
      // Optional: also allow selecting sub-subfolders if needed
      // this.subfolders2 = res.data.folders || [];
    });
  },

  // Triggered when 2nd-level subfolder is selected
  loadFiles() {
    if (!this.selectedSubFolder2) return;
    const folderPath = this.selectedFolder + '/' + this.selectedSubFolder2;
    this.loadFilesFromFolder(folderPath);
  },

generateExcel() {
  if (!this.selectedRows.length) {
    alert("Select rows first");
    return;
  }

  const groups = {};

  // GROUP DATA BY FILE + PAGE
  this.selectedRows.forEach(item => {
    const key = item.file + "_" + item.page;

    if (!groups[key]) {
      groups[key] = {
        file: item.file,
        page: item.page,
        headers: item.headers,
        header_info: item.header_info || {},
        rows: []
      };
    }

    groups[key].rows.push(item.row);
  });

  const excelData = [];
  const headerRowIndexes = []; // store indexes of table headers for styling

  Object.values(groups).forEach(group => {
    const info = group.header_info;

    // 1️⃣ Header info rows (Title, Line, Aircraft, File)
    excelData.push([`Title: ${info.title || '-'}`]);
    excelData.push([`Line: ${info.line_number || '-'}`]);
    excelData.push([`Aircraft: ${info.airplane_id || '-'}`]);
    excelData.push([`File: ${group.file || '-'} - Page ${group.page || '-'}`]);
    excelData.push([]); // empty row before table

    // 2️⃣ Table headers
    headerRowIndexes.push(excelData.length); // save index BEFORE pushing
    excelData.push(group.headers);

    // 3️⃣ Table rows
    group.rows.forEach(row => {
      const rowData = group.headers.map((header, index) => {
        if (row) {
          if (Array.isArray(row)) {
            return row[index] || "";
          } else if (typeof row === "object") {
            return row[header] || "";
          }
        }
        return "";
      });
      excelData.push(rowData);
    });

    // 4️⃣ Empty rows between tables
    excelData.push([]);
    excelData.push([]);
  });

  // CREATE WORKSHEET
  const worksheet = XLSX.utils.aoa_to_sheet(excelData);

  // =============================
  // HEADER STYLE APPLY
  // =============================
  headerRowIndexes.forEach(rowIndex => {
    const headers = excelData[rowIndex];
    headers.forEach((h, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
      if (!worksheet[cellAddress]) return;

      worksheet[cellAddress].s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "828282" } },
        alignment: { horizontal: "center" }
      };
    });
  });

  // Style header info rows (bold)
  for (let r = 0; r < excelData.length; r++) {
    const row = excelData[r];
    if (
      row.length === 1 &&
      row[0] && // ✅ safe check
      (row[0].includes("Title:") ||
        row[0].includes("Line:") ||
        row[0].includes("Aircraft:") ||
        row[0].includes("File:"))
    ) {
      const cellAddress = XLSX.utils.encode_cell({ r, c: 0 });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = { font: { bold: true } };
      }
    }
  }

  // Column width auto (optional)
  worksheet["!cols"] = [{ wch: 30 }, { wch: 60 }, { wch: 25 }, { wch: 20 }];

  // CREATE WORKBOOK AND EXPORT
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Maintenance");

  const wbout = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true
  });

  const blob = new Blob([wbout], { type: "application/octet-stream" });
  saveAs(blob, "maintenance_results.xlsx");
},





  search() {
  if (!this.keyword || !this.selectedFolder || !this.selectedFiles.length) {
    alert("Select folder, file(s), and enter keyword");
    return;
  }

  let folderPath = this.selectedFolder;

if (this.selectedSubFolder2) {
  folderPath += '/' + this.selectedSubFolder2;
}

  this.isLoading = true;
  this.results = [];

  axios.post(
    "https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/indexsearch2",
    {
      location: this.location,
      keyword: this.keyword,
     folder: folderPath, 
      files: this.selectedFiles   // 👈 array
    }
  )
  .then(res => {;
    console.log(res)
    console.log(JSON.stringify(res))
    this.results = res.data;
    this.searched = true;
  })
  .finally(() => {
    this.isLoading = false;
  });
},



  },
};
</script>

<style scoped>
.search-container {
  padding: 20px;
}



button {
  padding: 6px 12px;
  cursor: pointer;
}
</style>
